import { connect } from 'react-redux';
import { getTranslationModule } from '../../languages';

const withLocalization = (WrappedComponent, dictionaryNestingPath = '') => {
  const isMultipleModulePath = Array.isArray(dictionaryNestingPath);

  return connect(({ language }) => {
    let translationObject = {};

    if (isMultipleModulePath) {
      dictionaryNestingPath.forEach(singlePath => {
        const explodedPath = singlePath.split('/');
        const moduleName = explodedPath[explodedPath.length - 1];
        translationObject[moduleName] = getTranslationModule(singlePath, language);
      });
    }

    else {
      translationObject = getTranslationModule(dictionaryNestingPath, language);
    }

    if (!translationObject) {
      throw new Error(
        `Could not find translation module in the provided path "${dictionaryNestingPath}"`
      );
    }

    return {
      language,
      formatDateTime(dateTimeString, format = {
        month: 'short',
        day: 'numeric'
      }) {
        return new Intl
          .DateTimeFormat(language, format)
          .format(new Date(dateTimeString));
      },

      translate(message, replacements) {
        let translatedText;

        if (isMultipleModulePath) {
          const explodedTranslationId = message.split('/');

          if (explodedTranslationId.length !== 2) {
            throw new Error(
              `Invalid translation message format!
              Provide the submodule name in front of the translation id (message)
              separated by "/" (e.g. "header/header-item-translation", passed: ${message})`
            );
          }

          const moduleName = explodedTranslationId[0];

          if (!translationObject[moduleName]) {
            console.error(
              'translation module:', translationObject,
              'passed submodule name:', moduleName,
              'imported submodules:', Object.keys(translationObject)
            );
            throw new Error(
              `submodule name "${moduleName}" could not be found in the provided translation module - 
              perhaps its not imported or the module does not exist in the "${language}" translation file`
            );
          }

          const translationId = explodedTranslationId[1];
          translatedText = translationObject[moduleName][translationId];
        }

        else {
          translatedText = translationObject[message];
        }

        if (!translatedText) {
          if (translatedText !== '') {
            console.error(
              `Translation for message "${message}" could not be found`,
              'translation module:', translationObject,
              'message:', message
            );

            return message;
            // throw new Error(`Translation for message "${message}" could not be found`);
          }

          // console.warn(`Message "${message}" is not translated yet.`, 'Translation module:', translationObject);
        }

        if (replacements) {
          return translatedText.replace(/{(.+?)}/g, (match, captured) => replacements[captured] || '');
        }

        return translatedText;
      }
    };
  })(WrappedComponent);
};

export default withLocalization;